/* TW card gallery: photo arrows and swipe on product cards (see snippets/tw-card-gallery.liquid) */
(function () {
  if (window.twCardGallery) return;
  window.twCardGallery = true;

  function setup(root) {
    if (root.__twcg) return;
    root.__twcg = true;
    var photos;
    try { photos = JSON.parse(root.getAttribute('data-tw-cg-photos') || '[]'); } catch (e) { photos = []; }
    if (photos.length < 2) return;
    var card = root.closest('.product_image') || root.parentElement;
    var box = card.querySelector('.image__container') || card;
    var link = card.querySelector('a[href]');
    var dots = root.querySelectorAll('.tw-cg__dot');
    var status = root.querySelector('.tw-cg__status');
    var index = 0;
    var layer = null;

    function show(i) {
      index = (i + photos.length) % photos.length;
      if (index === 0) {
        if (layer) layer.classList.remove('is-shown');
      } else {
        if (!layer) {
          layer = document.createElement('img');
          layer.className = 'tw-cg__layer';
          layer.decoding = 'async';
          layer.setAttribute('sizes', '(min-width: 799px) 33vw, (min-width: 481px) 50vw, 100vw');
          box.appendChild(layer);
        }
        var p = photos[index];
        layer.classList.remove('is-shown');
        layer.onload = function () { layer.classList.add('is-shown'); };
        layer.alt = p.alt || '';
        layer.srcset = p.srcset;
        layer.src = p.src;
        if (layer.complete && layer.naturalWidth) layer.classList.add('is-shown');
      }
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === index);
      if (status) status.textContent = 'Photo ' + (index + 1) + ' of ' + photos.length;
    }

    function step(dir, event) {
      if (event) { event.preventDefault(); event.stopPropagation(); }
      show(index + dir);
    }

    root.querySelector('[data-tw-cg-prev]').addEventListener('click', function (e) { step(-1, e); });
    root.querySelector('[data-tw-cg-next]').addEventListener('click', function (e) { step(1, e); });

    // Swipe left/right on the photo (touch screens)
    var startX = 0, startY = 0, swiping = false;
    card.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    card.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        step(dx < 0 ? 1 : -1);
        if (link) {
          var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); link.removeEventListener('click', block, true); };
          link.addEventListener('click', block, true);
          setTimeout(function () { link.removeEventListener('click', block, true); }, 400);
        }
      }
    }, { passive: true });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-tw-cg]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Cards added later ("Load more", recommendations, theme editor)
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; init(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
